import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import apiRequest from '../../service/vpc/request';
import trustApiRequest from '../../service/trust_vpc/request';
import NetworkIndex from '../../mixin/NetworkIndex/index';
import KpcViewTitle from "../../components/KpcViewTitle/index.vue";
import Button from 'kpc/components/button';
import * as _ from 'lodash';
import { Tabs, Tab } from 'kpc/components/tabs';
import * as vifService from "../../service/vpc/vif";

const getTabName = (route: any): string => {
    if (route.name === 'groupDetailInstance' || route.name === 'trustGroupDetailInstance') {
        return route.params.type;
    }
    return route.name.replace(route.path.indexOf('trust-vpc') !== -1 ? 'trustGroupDetail' : 'groupDetail', '');
}
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
@Component({
    components: {
        KpcViewTitle,
        Tabs, Tab,
        Button
    },
    mixins: [NetworkIndex],
    // beforeRouteEnter(to, from, next) {
    //     next((vm: any) => {
    //         vm.tab = getTabName(to);
    //     })
    // },
    // beforeRouteUpdate(to, from, next) {
    //     let me: any = this;
    //     me.tab = getTabName(to);
    //     next();
    // }
})
export default class GroupDetailView extends Vue {
    tab = '';
    subs: any[] = [];
    vpcId = '';
    subnetId = '';
    groupId = '';
    groupName = '';
    detail: any = {};
    inRuleList: any[] = [];
    outRuleList: any[] = [];
    SecurityGroupType = '';
    get notReserveSubnet() {
        return this.detail.SubnetType === 'Normal' || this.detail.SubnetType === 'Physical'
    }

    get isTrustVpc(){
        const me: any = this;
        let str = me.$route.path;
        return str.indexOf('trust-vpc') !== -1
    }    

    get request(){
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    get backRoute(){
        return this.isTrustVpc ? '#/trust-vpc/group' : '#/vpc/group'
    }

    public changeTab(tab: string) {
        this.tab = tab;
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            vm.tab = getTabName(to);
        })
    }

    public beforeRouteUpdate(to: any, from: any, next: any) {
        let me: any = this;
        me.tab = getTabName(to);
        next();
    }

    goTo(name: string, type?: string) {

        let route: any = {
            name: this.isTrustVpc ? `trustGroupDetail${name}` : `groupDetail${name}`,
            params: _.clone(this.$route.params),
        }
        if (type) {
            route.params.type = type;
        }

        this.$router.push(route);
    }

    async mounted() {
        let me: any = this;
        me.region = this.$route.params.region;
        me.vpcId = this.$route.params.vpcId;
        me.groupId = this.$route.params.groupId;
        if(me.vpcId == '0') {
            me.SecurityGroupType = 'global'
        }
        let detail1 = await this.DescribeSecurityGroups();
        let detail2 = await this.QuerySubnet();
        this.detail = _.merge(detail2, detail1); //这个merge顺序是因为CreateTime以安全组创建时间为主
    }

    DescribeSecurityGroups() {
        return new Promise(resolve => {
            // apiRequest.DescribeSecurityGroups({
            this.request.DescribeSecurityGroups({
                Region: this.region,
                'SecurityGroupId.1': this.groupId
            }).done((data: any) => {
                let detail = _.get(data, 'SecurityGroupSet[0]', {});
                this.subs = [{
                    title: detail.SecurityGroupName
                }];
                this.groupName = detail.SecurityGroupName;

                let SecurityGroupEntrySet = _.get(detail, 'SecurityGroupEntrySet');
                this.inRuleList = _.filter(SecurityGroupEntrySet, (item) => {
                    return item.Direction == 'in';
                });
                this.outRuleList = _.filter(SecurityGroupEntrySet, (item) => {
                    return item.Direction == 'out';
                });

                resolve(detail)
            }).fail(() => {
                resolve({})
            })
        })
    }

    QuerySubnet() {
        return new Promise((resolve) => {
            // apiRequest.QuerySubnet(
            this.request.QuerySubnet(
                {
                    Region: this.region,
                    'SubnetId.1': this.subnetId
                }
            ).done((data: any) => {
                resolve(data);
            }).fail(() => {
                resolve({})
            });
        })
    }


    showVifType(vifType: string) {
        return vifService.VifTypeMap[vifType] || '--';
    }

    getNetworkInterfaceList(type: string, page: number, limit: number, searchField: string, searchValue: string) {
        let params: any = {
            Region: this.region,
            SgId: this.groupId,
            InstanceType: type,
            MaxResults: limit,
            NextToken: (page - 1) * limit + 1
        }

        if (searchValue) {
            params[searchField] = searchValue;
        }

        return new Promise(resolve => {
            // apiRequest.DescribeNetworkInterfaces(params).done((data: any) => {
            this.request.DescribeNetworkInterfaces(params).done((data: any) => {
                resolve(data);
            }).fail(() => {
                resolve({});
            })
        })
    }

}
